import { BsCheckCircleFill } from "react-icons/bs";
import { AiFillCloseCircle } from "react-icons/ai";
import styles from "./InclusionExclusionSection.module.scss";

const InclusionExclusionSection = ({ experience }) => {
  const { inclusions_exclusions } = experience;

  const inclusions = [];
  const exclusions = [];

  inclusions_exclusions.forEach((item) => {
    if (
      item.included === true &&
      !!Object.keys(item.inclusion_exclusion).length
    ) {
      inclusions.push(item.inclusion_exclusion);
    } else if (!!Object.keys(item.inclusion_exclusion).length) {
      exclusions.push(item.inclusion_exclusion);
    }
  });

  const generateListHTML = (array, type) => {
    const elements = array.map((item, index) => {
      if (item === null) {
        return;
      }
      return (
        <li key={index} className={`${styles.inclusionItem}`}>
          <span className={`${styles.inclusionIcon}`}>
            {type === "inclusion" ? (
              <BsCheckCircleFill />
            ) : (
              <AiFillCloseCircle size="1.15em" />
            )}
          </span>
          <span className={`${styles.inclusionName}`}>{item.name}</span>
        </li>
      );
    });
    return elements;
  };

  return (
    <div className={`${styles.inclusionExclusionContainer} text-container`}>
      <div className={`${styles.column} ${styles.inclusionColumn}`}>
        <ul className={`${styles.inclusionList}`}>
          {generateListHTML(inclusions, "inclusion")}
        </ul>
      </div>
      <div className={`${styles.column} ${styles.exclusionColumn}`}>
        <ul className={`${styles.inclusionList}`}>
          {generateListHTML(exclusions, "exclusion")}
        </ul>
      </div>
    </div>
  );
};

export default InclusionExclusionSection;
